import Vue from 'vue'
import PouchDB from 'pouchdb';
import axios from 'axios';
import {Directory, Encoding, Filesystem} from "@capacitor/filesystem";
import {Share} from "@capacitor/share";
import {Capacitor} from "@capacitor/core";
import * as XLSX from "xlsx";
import {isPlatform} from "@ionic/vue";
import {saveAs} from 'file-saver'


const namespaced = true

let dbSettings = {revs_limit: 7, auto_compaction: true};


const state = {
    imageDB: new PouchDB('imageDB', dbSettings),
    cache: {}

}

const actions = {


    async createExcelSheet({state}, payload) {
        const worksheet = XLSX.utils.json_to_sheet(payload.data)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        let type;
        if (!isPlatform('ios') && !isPlatform('android')) {
            type = 'array'
        } else {
            type = 'base64'
        }
        const wbout = XLSX.write(workbook, {bookType: 'xlsx', type: type})
        return wbout;
    },

    //NEW
    async saveAndExportFile({state}, payload) {
        let fileToSave = payload.file;
        let filename = payload.name;
        let title = payload.title;
        const path = `${filename}`

        const platform = Capacitor.getPlatform();
        const isNativeMobile = platform === 'ios' || platform === 'android';

        if (!isNativeMobile) {
            // Browser: use Blob and FileSaver
            const blob = new Blob([fileToSave], {type: payload.type || 'application/octet-stream'})
            saveAs(blob, filename)
        } else {
            // Mobile: convert Uint8Array to base64 string
            const base64String = await this.dispatch('files/uint8ArrayToBase64', fileToSave);
            
            // Request permissions on Android
            if (platform === 'android') {
                try {
                    let permStatus = await Filesystem.checkPermissions();
                    if (permStatus.publicStorage !== 'granted') {
                        permStatus = await Filesystem.requestPermissions();
                    }
                } catch (e) {
                    console.log('Permission check not available, continuing...', e);
                }
            }

            // Try Documents first, fall back to Cache
            let writeDir = Directory.Documents;
            try {
                await Filesystem.writeFile({
                    path,
                    data: base64String,
                    directory: writeDir,
                });
            } catch (e) {
                console.warn('Documents write failed, trying Cache directory', e);
                writeDir = Directory.Cache;
                await Filesystem.writeFile({
                    path,
                    data: base64String,
                    directory: writeDir,
                });
            }

            const file = await Filesystem.getUri({
                path: filename,
                directory: writeDir,
            });

            await Share.share({
                title: title,
                url: file.uri,
                dialogTitle: title,
            });
        }

    },

    async uint8ArrayToBase64({}, uint8Array) {
        // Convert Uint8Array to base64 string
        let binary = '';
        const len = uint8Array.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(uint8Array[i]);
        }
        return window.btoa(binary);
    },


    //TODO:doesn´t work as expected
    async downloadImage({state}, url) {

        let s3link = 'https://fileserver.s3-de-central.profitbricks.com/';
        let parts = url.split('/')
        let file = parts[4]
        let width = parts[6] * parts[8]
        let height = parts[7] * parts[8]
        let ratio = parts[8]
        console.log(file, width, height, ratio)

        let image = s3link + file + '-' + width + '-' + height + '-' + ratio + '-undefined-image'
        try {
            let blob = (await axios({
                method: 'GET',
                url: image,
                headers: {
                    'Content-Type': 'text/plain',

                    'x-api-key': undefined
                },
                responseType: 'blob'
            })).data;
            console.log('blob to download', blob)

           /*let obj = {
                _id: 'blob/' + image,
                _attachments: {
                    'image': {
                        content_type: blob.type,
                        data: blob
                    }
                }
            }*/
            state.imageDB.get
            state.imageDB.putAttachment('blob/' + image, 'image', blob, 'image/png').then(()=>{
                return state.imageDB.get('blob/' + image, {attachments:true})
            }).then(()=>{
                return state.imageDB.getAttachment('blob/' + image, 'image')
            }).then(_blob=>{
                return URL.createObjectURL(_blob);
            })


            /*state.imageDB.put(obj).then(() => {
                return state.imageDB.getAttachment('blob/' + image, 'image')

            }).then(blob => {
                return URL.createObjectURL(blob);
            })*/
        } catch (err) {
            console.log(err)
        }

    },

    getImage: async ({state, dispatch}, url) => {

        console.log('statecache', state.cache['blob/' + url])

        if (!state.cache['blob/' + url]) {

            try {
                let blob = await state.imageDB.getAttachment('blob/' + url, 'image');
                console.log('blob', blob)
                if (blob) {
                    if (blob.size !== 0) {
                        state.cache['blob/' + url] = URL.createObjectURL(blob);
                        return state.cache['blob/' + url];
                    } else {
                        state.imageDB.get('blob/' + url).then((x) => {
                            state.imageDB.remove(x).then(() => {
                                //dispatch('downloadImage', url)
                            }).catch(console.log)
                        }).catch(console.log);
                        return url;
                    }
                } else {
                    dispatch('downloadImage', url)
                    return url;
                }
            } catch (err) {
                console.log('fetcherr', err)
                let res = await dispatch('downloadImage', url)
                console.log(res)
                return url;
            }


        } else {
            return state.cache['blob/' + url]
        }
    }
}
const mutations = {
    setDB: (state, data) => {
        Vue.set(state, 'imageDB', data)
    },
}
const getters = {
    getDB: (state) => {
        return state.imageDB;
    },
}

export const files = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
